exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Viewport[data-v-162d7ce8] {\n  position: relative;\n  display: table-cell;\n}\n.Viewport_Inner[data-v-162d7ce8] {\n    box-sizing: border-box;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding: 20px;\n    text-align: center;\n    overflow: auto;\n}\n", ""]);

// exports
